import { combineReducers } from 'redux'
import app from './app'
import loans from './loans'
import { appTypes } from '../actions/types'

const reducers = combineReducers({
  app,
  loans,
})

export default (state, action) => {
  if (action.type === appTypes.backToState) return action.state
  return reducers(state, action)
}
